// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/modules/products/v2_0/shared/News/news.scss
// module id = 1425
// module chunks = 10